import { render, staticRenderFns } from "./StatementDetail.vue?vue&type=template&id=7c5273c8&"
import script from "./StatementDetail.vue?vue&type=script&lang=js&"
export * from "./StatementDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatementDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports